import type { DeepReadonly } from "@itandi/itandi-bb-ui";
import React from "react";
import { animateScroll as scroll } from "react-scroll/modules";
import { ChatMessageArea } from "~/components/common/chat/messages/ChatMessageArea";
import { ChatPostArea } from "~/components/common/chat/post/ChatPostArea";
import type { Deal } from "~/models/Deal";
import type { Message, MessageReceiver } from "~/models/Message";
import Styles from "./ChatPageContainer.module.scss";

type Props = DeepReadonly<{
	deal: Deal;
	handleMutate: () => Promise<void>;
	messages: Message[];
	receiver?: MessageReceiver;
}>;

/**
 * スマホなどで画面いっぱいに表示するチャット画面
 *
 * @param deal
 * @param messages
 * @param handleMutate
 * @param receiver メッセージの受信者
 * @constructor
 */
export const ChatPageContainer: React.FC<Props> = ({
	deal,
	messages,
	handleMutate,
	receiver = "maintenance_company"
}: Props) => {
	React.useEffect(() => {
		if (messages !== null) {
			// メッセージが読み込まれるたびに一番下までスクロール
			// NOTE: ChatMessageArea内のscrollerはスクロール可動域のdomが異なるため動作しない
			scroll.scrollToBottom({
				duration: 0
			});
		}
	}, [messages]);
	return (
		<>
			<div className={Styles.ChatPageContainer}>
				<ChatMessageArea
					deal={deal}
					handleMutate={handleMutate}
					isOpen
					messages={messages}
					receiver={receiver}
				/>
			</div>
			<ChatPostArea
				deal={deal}
				handleMutate={handleMutate}
				isVendor={receiver !== "maintenance_company"}
			/>
		</>
	);
};
